
<template>
   <div>
      <v-container>
         <v-layout row wrap>

            <img src="/static/img/salutance/silhouette.png" class="silhouette"/>

            <v-flex xs10 offset-xs1>
               <v-card class="mycard">
                  <v-card-text>
                     <h1>IMC et perte de poids après chirurgie</h1>

                     <h3>Remplissez le formulaire suivant</h3>

                     <v-form v-model="valid" ref="form1">

                        <v-text-field
                           label="Poids actuel (kg)"
                           ref="weight"
                           v-model="weight"
                           :rules="weightRules"
                           suffix="kg"
                           required
                        ></v-text-field>

                        <v-text-field
                           label="Poids avant la chirurgie (kg)"
                           ref="weightBefore"
                           v-model="weightBefore"
                           :rules="weightRules"
                           suffix="kg"
                           required
                        ></v-text-field>

                        <v-text-field
                           label="Taille (cm)"
                           ref="height"
                           v-model="height"
                           :rules="heightRules"
                           suffix="cm"
                           required
                        ></v-text-field>

                     </v-form>
                  </v-card-text>
               </v-card>
            </v-flex>

            <v-flex xs10 offset-xs1>
               <v-card class="mycard" v-if="valid">
                  <v-card-title primary-title><h1>Résultat</h1></v-card-title>
                  <v-card-text>

                        <v-list>
                           <v-list-tile>
                              <v-list-tile-content>
                                 <v-list-tile-title>Perte d'excés de poids (%)</v-list-tile-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                 <v-list-tile-action-text class="title">{{ excessWeightloss }}</v-list-tile-action-text>
                              </v-list-tile-action>
                           </v-list-tile>
                           <v-divider></v-divider>
                           <v-list-tile>
                              <v-list-tile-content>
                                 <v-list-tile-title>IMC actuel</v-list-tile-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                 <v-list-tile-action-text class="title">{{ bmi }}</v-list-tile-action-text>
                              </v-list-tile-action>
                           </v-list-tile>
                        </v-list>

                  </v-card-text>
               </v-card>
            </v-flex>
         
         </v-layout>
      </v-container>
   </div>
</template>

<style scoped>
   .subcategory {
      margin-top: 40px;
   }
</style>

<script>
   import moment from 'moment'

   export default {

      mounted: function() {
         // refs are not reactive, this is the way to get template component instances
         this.heightInputComp = this.$refs.height
         this.weightInputComp = this.$refs.weight
         this.weightBeforeInputComp = this.$refs.weightBefore
      },

      data: () => ({
         valid: false,
         height: '',
         heightRules: [
            (v) => !!v || 'Champ obligatoire',
            (v) => v && !isNaN(parseInt(v)) || 'La taille doit être un nombre entier (cm)',
            (v) => v && parseInt(v) >= 70 && parseInt(v) <= 250 || 'La taille doit être comprise entre 70 et 250',
         ],
         heightInputComp: null,
         weight: '',
         weightBefore: '',
         weightRules: [
            (v) => !!v || 'Champ obligatoire',
            (v) => v && !isNaN(parseInt(v)) || 'Le poids doit être un nombre entier (kg)',
            (v) => v && parseInt(v) >= 30 && parseInt(v) <= 250 || 'Le poids doit être compris entre 30 et 250',
         ],
         weightInputComp: null,
         weightBeforeInputComp: null,
      }),

      methods: {
         heightValid: function() {
            return this.heightInputComp.errorBucket.length === 0
         },
         weightValid: function() {
            return this.weightInputComp.errorBucket.length === 0
         },
         weightBeforeValid: function() {
            return this.weightBeforeInputComp.errorBucket.length === 0
         },
      },
      
      computed: {
         bmi: function() {
            if (this.heightValid() && this.weightValid()) {
               let h = this.height / 100.0
               let result = this.weight / (h * h)
               return Math.round(result * 10) / 10
            } else {
               return -1
            }
         },
         excessWeightloss: function() {
            if (this.heightValid() && this.weightValid()) {
               let h = this.height / 100.0
               let result = 100*(this.weightBefore - this.weight) / (this.weightBefore - 25 * h*h)
               return Math.round(result)
            } else {
               return -1
            }
         }
      },
   }
</script>


<style scoped>

.header {
   height: 180px;
   background-color: #74c5c5;
}

.silhouette {
   position: absolute;
   top: 160px;
   right: 20px;
   height: 800px;
   z-index: 1000;
   opacity: 0.5;
}

.mycard {
  margin: 20px;
  padding: 20px;
}

</style>



// WEBPACK FOOTER //
// IMCWeightLossCalc.vue?be22d6e8